import type { ReactNode } from 'react';
import cn from 'classnames';

interface FieldHintProps {
  children?: ReactNode;
  className?: string;
}

/**
 * Hint under a field or a group of fields, outside the field itself: it applies to several inputs
 * at once (start and end dates) and is not mixed with the field's error message
 */
export const FieldHint = ({ children, className }: FieldHintProps) => {
  if (!children) return null;
  return <p className={cn('text-xs text-grey-secondary', className)}>{children}</p>;
};
